import { JSONClient } from './bootstrap'

export const partnerDetails = async (token) => {
    const response = await JSONClient.post('/partner/partnerInfo', {}, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })
    return response
}


export const cashoutPartnerBalance = async (token, cryptoAddress) => {
    const response = await JSONClient.post('/partner/cashout', {
        cryptoAddress
    }, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })
    return response
}

export const partnerTableHistory = async (token, type, page, limit) => {
    const response = await JSONClient.post('/history/getPartnerHistory', {
        page,
        limit,
        balanceAction: type
    }, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })
    return response
}

export const partnerChart = async (token, startTime, endTime) => {
    const response = await JSONClient.post('/history/getPartnerEarningChart', {
        startTime: new Date(startTime).getTime(),
        endTime: new Date(endTime).getTime(),
    }, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })
    return response
}